import { Component } from '@angular/core';
import { TipoConteudo as TipoConteudo } from 'src/app/model/arquivo.model';

@Component({
    selector: 'app-atualizacao-informacoes-lote-pesquisa',
    templateUrl: './atualizacao-informacoes-lote-pesquisa.component.html',
    standalone: false
})
export class AtualizacaoInformacoesLotePesquisaComponent {

  tiposConteudo: TipoConteudo[] = [TipoConteudo.ATUALIZACAO_INFO_RISCO, TipoConteudo.ACOMPANHAMENTO_PROCESSUAL];
  formatoArquivo: string = "csv";
}


